<template>
  <div class="table" :style="{ width: width, height: height }" style="display:flex !important; justify-content:left;">
    <table v-if="this.tableData && this.tableData.AREAS && this.tableData.DATA">
      <thead>
        <tr>
          
          <th>지역 </th>
          <template v-if="!isColumnZero('POSITIVE')">
            <th>POSITIVE</th>
          </template>
          <template v-if="!isColumnZero('NEGATIVE')">
            <th>NEGATIVE</th>
          </template>
          <template v-if="!isColumnZero('INCONCLUSIVE')">
            <th>INCONCLUSIVE</th>
          </template>
          
        </tr>
      </thead>
      <tbody>
        <tr v-for="area in tableData.AREAS" :key="area">
          <template v-if="!isColumnZero('POSITIVE') && !isColumnZero('NEGATIVE') && !isColumnZero('INCONCLUSIVE')">
            <td style="text-align:left !important;">{{ area }} ({{ priceToString(tableData.DATA[area].POSITIVE + tableData.DATA[area].NEGATIVE +tableData.DATA[area].INCONCLUSIVE ) }})</td>
          </template>
          <template v-if="!isColumnZero('POSITIVE')">
            <td style="text-align:right !important;">{{ priceToString( tableData.DATA[area].POSITIVE) }} ({{ calculateProportion(area, 'POSITIVE') }}%)</td>
          </template>
          <template v-if="!isColumnZero('NEGATIVE')">
            <td  style="text-align:right !important;">{{ priceToString( tableData.DATA[area].NEGATIVE )}} ({{ calculateProportion(area, 'NEGATIVE') }}%)</td>
          </template>
          <template v-if="!isColumnZero('INCONCLUSIVE')">
            <td  style="text-align:right !important;">{{ priceToString( tableData.DATA[area].INCONCLUSIVE) }} ({{ calculateProportion(area, 'INCONCLUSIVE') }}%)</td>
          </template>
        </tr>
        <tr>
          <td style="text-align:left !important">
            합계 ({{priceToString( calculateOverallTotal()) }})
          </td>
          <template v-if="!isColumnZero('POSITIVE')">
            <td style="text-align:right !important;">{{ priceToString( calculateTotals('POSITIVE')) }} ({{ calculateTotalProportion('POSITIVE')}}%)</td>
          </template>
          <template v-if="!isColumnZero('NEGATIVE')">
            <td style="text-align:right !important;">{{ priceToString( calculateTotals('NEGATIVE')) }} ({{ calculateTotalProportion('NEGATIVE')}}%)</td>
          </template>
          <template v-if="!isColumnZero('INCONCLUSIVE')">
            <td style="text-align:right !important;">{{ priceToString( calculateTotals('INCONCLUSIVE')) }} ({{ calculateTotalProportion('INCONCLUSIVE')}}%)</td>
          </template>

        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'AreaScreenBarTable',
  props: {
    tableData: {
      type: Object,
      default: () => ({
      
        AREAS: ['A', 'B', 'C', 'D'],
        DATA: {
          A: { POSITIVE: 1, NEGATIVE: 2, INCONCLUSIVE: 2},
          B: { POSITIVE: 1, NEGATIVE: 2, INCONCLUSIVE: 2},
          C: { POSITIVE: 1, NEGATIVE: 2, INCONCLUSIVE: 2},
          D: { POSITIVE: 1, NEGATIVE: 2, INCONCLUSIVE: 2}
        }
      


      })
    },
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 500
    }
  },
  methods: {
    priceToString(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    calculateTotals(type) {
      // 각 타입(POSITIVE, NEGATIVE, INCONCLUSIVE)의 합계를 계산
      return Object.values(this.tableData.DATA).reduce((sum, data) => {
        return sum + (data[type] || 0); // 값이 없을 경우 0으로 처리
      }, 0);
    },
    calculateOverallTotal() {
      // 모든 값의 총합 계산
      return Object.values(this.tableData.DATA).reduce((sum, data) => {
        return (
          sum +
          (data.POSITIVE || 0) +
          (data.NEGATIVE || 0) +
          (data.INCONCLUSIVE || 0)
        );
      }, 0);
    },
    calculateTotalProportion(type) {
      // 특정 타입(POSITIVE, NEGATIVE, INCONCLUSIVE)의 비율 계산
      const overallTotal = this.calculateOverallTotal();
      const total = this.calculateTotals(type);
      return overallTotal ? ((total / overallTotal) * 100).toFixed(2) : 0;
    },

    calculateProportion(area, type) {
      const data = this.tableData.DATA[area];
      const total = data.POSITIVE + data.NEGATIVE + data.INCONCLUSIVE;
      const value = data[type];
      


      let proportion="0.00";
      if (total != 0){
        proportion = ((value / total) * 100).toFixed(2);
      }
      
      return proportion;
      
    },
    isColumnZero(type) {
      return Object.values(this.tableData.DATA).every(data => data[type] === 0);
    }
  }
}
</script>

<style scoped>
.table {
  margin-top: 12px;
  width: v-bind(width);
  height: v-bind(height);
  margin-left: calc(10%); /* Move table to 1/4 of the width */

}

.table th {
  background-color:#04AA !important;
  color:white !important;
  font-size:12px !important;

  padding-left:10px !important;
  padding-right:12px !important;
  padding-bottom:4px !important;
  padding-top:4px !important;
  
  text-align: center !important;
  border: 1px sold rgba(2, 14, 31, 0.667) !important;
}

.table td {
  text-align: center;
  font-size: 11px; /* Smaller font size */
  padding:2px !important;
  margin-left:2px !important;
  border: 1px solid #04AA !important;
}
.table tbody {
  margin-top: 10px; /* 10px margin at the top of tbody */
}
.table tr {
  border-bottom: none;
}
</style>
